import { render, staticRenderFns } from "./PresubXsaleComponent.vue?vue&type=template&id=8408e1b0"
import script from "./PresubXsaleComponent.vue?vue&type=script&lang=ts"
export * from "./PresubXsaleComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports